@let reviewForm = form();
@let templateChoice = template();

<div [formGroup]="reviewForm">
  <app-pan-form-control>
    <app-pan-floating-label>Template</app-pan-floating-label>

    <ng-select
      data-testid="template-dropdown"
      [(ngModel)]="template"
      [ngModelOptions]="{ standalone: true }"
      [items]="availableTemplates()"
      bindLabel="template"
      [clearable]="false"
      (ngModelChange)="changeTemplate()"
    ></ng-select>
  </app-pan-form-control>

  @if (templateChoice) {
    <fieldset class="mt-2 border border-solid border-gray-300 p-3" [hidden]="templateChoice.template === 'None'">
      <legend class="text-sm font-bold text-gray-600">Findings</legend>

      <div class="grid grid-cols-2 gap-2">
        @for (field of templateChoice.fields; track field.formControlName) {
          <app-pan-form-control>
            <app-pan-floating-label [for]="field.formControlName"> {{ field.label }}</app-pan-floating-label>

            @switch (field.type) {
              @case ("text") {
                <input
                  panInput
                  class="w-full"
                  type="text"
                  [formControlName]="field.formControlName"
                  [placeholder]="field.placeholder"
                  [attr.data-testid]="field.formControlName"
                  (change)="generateCommentsFromTemplate()"
                  (focusout)="generateCommentsFromTemplate()"
                />
              }
              @case ("number") {
                <input
                  panInput
                  class="w-full"
                  type="number"
                  [formControlName]="field.formControlName"
                  [placeholder]="field.placeholder"
                  [attr.data-testid]="field.formControlName"
                  (change)="generateCommentsFromTemplate()"
                  (focusout)="generateCommentsFromTemplate()"
                />
              }
              @case ("select") {
                <ng-select
                  formControlName="{{ field.formControlName }}"
                  [placeholder]="field.placeholder"
                  [attr.data-testid]="field.formControlName"
                  [items]="field.options"
                  (change)="generateCommentsFromTemplate()"
                  (focusout)="generateCommentsFromTemplate()"
                ></ng-select>
              }
            }
          </app-pan-form-control>
        }
      </div>

      <div class="text-sm italic p-2 mt-4" data-testid="generated-template-comments">
        {{ reviewForm.controls.comments.value }}
      </div>
    </fieldset>

    <div [class.hidden]="templateChoice.template !== 'None'">
      <app-review-form-findings [form]="reviewForm" [required]="true"></app-review-form-findings>
    </div>
  }
</div>
